import { render, staticRenderFns } from "./AutoCompleteUserSearch.vue?vue&type=template&id=d87d1ce4&scoped=true"
import script from "./AutoCompleteUserSearch.vue?vue&type=script&lang=ts"
export * from "./AutoCompleteUserSearch.vue?vue&type=script&lang=ts"
import style0 from "./AutoCompleteUserSearch.vue?vue&type=style&index=0&id=d87d1ce4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87d1ce4",
  null
  
)

export default component.exports